module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDEyIDE1Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjQwNTIiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTYgMTVzNi0zIDYtNy41di02TDYgMCAwIDEuNXY2QzAgMTIgNiAxNSA2IDE1eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/investor/shield.svg
// module id = xZsh
// module chunks = 1